"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextfieldLabel = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common/text/semantics/caption");
let TextfieldLabel = class TextfieldLabel extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.htmlFor = '';
        this.optional = false;
    }
    render() {
        return (0, lit_1.html) `
      <label for=${(0, if_defined_js_1.ifDefined)(this.htmlFor || undefined)}>
        <slot></slot>
        ${this.renderOptionalText()}
      </label>
    `;
    }
    renderOptionalText() {
        if (!this.optional)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-caption>선택입력</mm-caption>
    `;
    }
};
TextfieldLabel.styles = (0, lit_1.css) `
    label {
      display: flex;
      align-items: baseline;
      gap: var(--space-1);
      line-height: var(--size-24);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'for' })
], TextfieldLabel.prototype, "htmlFor", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], TextfieldLabel.prototype, "optional", void 0);
TextfieldLabel = __decorate([
    (0, decorators_js_1.customElement)('mm-textfield-label')
], TextfieldLabel);
exports.TextfieldLabel = TextfieldLabel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dGZpZWxkLWxhYmVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGV4dGZpZWxkLWxhYmVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFDM0QsZ0VBQXdEO0FBQ3hELHNEQUFtRDtBQUc1QyxJQUFNLGNBQWMsR0FBcEIsTUFBTSxjQUFlLFNBQVEsZ0JBQVU7SUFBdkM7O1FBU3lDLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFDN0IsYUFBUSxHQUFHLEtBQUssQ0FBQTtJQWtCL0MsQ0FBQztJQWhCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTttQkFDSSxJQUFBLHlCQUFTLEVBQUMsSUFBSSxDQUFDLE9BQU8sSUFBSSxTQUFTLENBQUM7O1VBRTdDLElBQUksQ0FBQyxrQkFBa0IsRUFBRTs7S0FFOUIsQ0FBQTtJQUNILENBQUM7SUFFTyxrQkFBa0I7UUFDeEIsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFbEMsT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUExQk0scUJBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7OztHQU9sQixDQUFBO0FBQzZDO0lBQTdDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDOytDQUFhO0FBQzdCO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQztnREFBaUI7QUFWbEMsY0FBYztJQUQxQixJQUFBLDZCQUFhLEVBQUMsb0JBQW9CLENBQUM7R0FDdkIsY0FBYyxDQTRCMUI7QUE1Qlksd0NBQWMifQ==